import { useState } from 'react';
import { useListContext, useNotify, useRefresh, useUnselectAll, useUpdateMany, useTranslate } from 'react-admin';

export const useUpdateManyController = ({ transform = null } = {}) => {
    const [open, setOpen] = useState(false);
    const [isPending, setPending] = useState(false);
    const { selectedIds, resource } = useListContext();
    const [updateMany] = useUpdateMany();
    const unselectAll = useUnselectAll(resource);
    const notify = useNotify();
    const translate = useTranslate();
    const refresh = useRefresh();

    const handleOpen = () => {
        if (isPending) return;
        setPending(false);
        setOpen(true);
    };

    const handleClose = () => {
        if (isPending) return;
        setPending(false);
        setOpen(false);
    };

    const handleSubmit = data => {
        if (transform) {
            data = transform(data);
        }
        data.ids = selectedIds;

        setPending(true);
        updateMany(
            resource,
            {
                ids: selectedIds,
                data: data,
            },
            {
                onSuccess: () => {
                    refresh();
                    notify(translate('common.operations.bulkUpdated'));
                    unselectAll();
                    if (resource === 'service-inspection') {
                        globalThis.dispatchEvent(new CustomEvent('serviceInspectionView:resetToList'));
                    }
                    handleClose();
                },
                onError: error => {
                    notify(error.message || translate('common.errors.errorRecordsNotUpdated'), { type: 'error' });
                },
                returnPromise: true,
            },
        ).finally(() => {
            setPending(false);
        });
    };

    return {
        open,
        isPending,
        handleOpen,
        handleClose,
        handleSubmit,
        selectedIds,
    };
};
